(() => {
  const bookingPath = '/pages/book-appointment';
  const oldBookingHost = 'theaestheticsspa.glossgenius.com';

  const updateBookingLinks = (root = document) => {
    root.querySelectorAll(`a[href*="${oldBookingHost}"]`).forEach((link) => {
      link.setAttribute('href', bookingPath);
      link.removeAttribute('target');
      link.removeAttribute('rel');
    });
  };

  const updateLegacyBookingText = (root = document.body) => {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || !node.nodeValue.includes('GlossGenius')) continue;
      node.nodeValue = node.nodeValue
        .replace('continue to GlossGenius', 'continue to our secure booking page')
        .replace('in GlossGenius', 'on our secure booking page')
        .replace('the Glow Facial package on our secure booking page', 'the Glow Facial booking page')
        .replace('GlossGenius', 'our secure booking page');
    }
  };

  const refreshBookingExperience = (root = document) => {
    updateBookingLinks(root);
    updateLegacyBookingText(root === document ? document.body : root);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest(`a[href*="${oldBookingHost}"]`);
    if (!link) return;
    event.preventDefault();
    window.location.assign(bookingPath);
  }, true);

  const initialize = () => {
    refreshBookingExperience();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          refreshBookingExperience(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
